import { gql } from '@apollo/client'

export const RESERVE_MONITORING_LIST_QUERY = gql`
  query ReserveMonitoringList(
    $providerAdapter: ProviderAdapter!
    $crsStatus: CRSStatus!
  ) {
    reserveMonitoringList(
      providerAdapter: $providerAdapter
      crsStatus: $crsStatus
    ) {
      pmsAccommodations {
        label
        value
        code
        id
      }
      uniqueChannelNames
      mappedChannelsForAccommodation {
        accommodationId
        accommodationName
        accommodationNameTranslatedList {
          label
          nativeLabel
          value
        }
        channels {
          channelId
          channelName
          channelName2
          ChannelCode
          isConnent
          thirty
          ninety
        }
      }
    }
  }
`
